import React from 'react';

import PropTypes from 'prop-types';
import { faEllipsis } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const DropdownMenuItems = ({ actions, row }) =>
  actions.map((action) =>
    action.type === 'divider' ? (
      <DropdownMenuSeparator key={action.id} />
    ) : (
      <DropdownMenuItem
        key={action.id}
        onClick={() => action.onClick(row)}
        variant={action.variant}
      >
        {action.label}
      </DropdownMenuItem>
    )
  );

const actionShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  variant: PropTypes.string,
});

DropdownMenuItems.propTypes = {
  actions: PropTypes.arrayOf(actionShape).isRequired,
};

const ActionsCell = ({ actions, row }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button size="icon" variant="ghost">
        <span className="sr-only">Open menu</span>
        <FontAwesomeIcon icon={faEllipsis} />
      </Button>
    </DropdownMenuTrigger>

    <DropdownMenuContent align="end">
      <DropdownMenuItems actions={actions} row={row} />
    </DropdownMenuContent>
  </DropdownMenu>
);

const rowShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
});

ActionsCell.propTypes = {
  actions: PropTypes.arrayOf(actionShape).isRequired,
  row: rowShape.isRequired,
};

export default ActionsCell;
